import './App.css';
import { useEffect } from 'react';
import {
  BrowserRouter as Router, Routes, Route, useLocation,
} from 'react-router-dom';
import Home from './pages/Home';
import Nav from './components/nav/Nav';
import Footer from './components/Footer';
import ContactUs from './components/ContactUs';
import Team from './components/Team';
import PromoteAndEarn from './components/Promote-Earn/PromoteAndEarn';
import ToastProvider from './components/utility/ToastProvider';
import { initializeGA, trackPageView } from './services/analytics';

// Component to track page views
function TrackingWrapper() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ToastProvider />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/team" element={<Team />} />
        <Route path="/promote-and-earn" element={<PromoteAndEarn />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics on app start
    initializeGA();
  }, []);

  return (
    <Router>
      <TrackingWrapper />
    </Router>
  );
}

export default App;
